import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  cn,
} from "@devhop/ui";
import { useState } from "react";

type NotificationDetailTextCellProps = {
  text: string | null | undefined;
  dialogTitle: string;
  variant?: "default" | "error";
  emptyLabel?: string;
};

const EXPAND_THRESHOLD = 72;

export function NotificationDetailTextCell({
  text,
  dialogTitle,
  variant = "default",
  emptyLabel = "—",
}: NotificationDetailTextCellProps) {
  const [open, setOpen] = useState(false);
  const value = text?.trim();

  if (!value) {
    return <span className="text-muted-foreground text-sm">{emptyLabel}</span>;
  }

  const canExpand =
    variant === "error" ||
    value.length > EXPAND_THRESHOLD ||
    value.includes("\n");

  return (
    <>
      <div className="min-w-[11rem] max-w-[22rem]">
        <p
          className={cn(
            "line-clamp-4 whitespace-pre-wrap break-words text-sm leading-relaxed",
            variant === "error"
              ? "text-destructive/90"
              : "text-foreground/90",
          )}
        >
          {value}
        </p>
        {canExpand ? (
          <Button
            type="button"
            variant="link"
            size="sm"
            className="mt-0.5 h-auto px-0 py-0 text-xs"
            onClick={() => setOpen(true)}
          >
            ເບິ່ງເຕັມ
          </Button>
        ) : null}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{dialogTitle}</DialogTitle>
          </DialogHeader>
          <div
            className={cn(
              "whitespace-pre-wrap break-words rounded-md border bg-muted/30 p-3 text-sm leading-relaxed",
              variant === "error" && "font-mono text-destructive",
            )}
          >
            {value}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
